import {Outlet, createFileRoute, redirect} from '@tanstack/react-router';
import {ForbiddenError} from '../errors';
import ForbiddenPage from '../pages/ForbiddenPage';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad({context, location}) {
    if (!context.auth.isAuthenticated) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing redirects
      throw redirect({
        to: '/sign-in',
        search: {redirect: location.href},
      });
    }
  },
  errorComponent({error}) {
    if (error instanceof ForbiddenError) {
      return <ForbiddenPage message={error.message} />;
    }
    throw error;
  },
  component: () => <Outlet />,
});
